export default function WorkflowCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-500 to-teal-600 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utb3BhY2l0eT0iLjEiLz48L2c+PC9zdmc+')] opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            准备好优化您的文档工作流程了吗？
          </h2>
          <p className="text-xl text-teal-50 mb-10 leading-relaxed">
            联系我们的专家团队，获取免费的文档工作流程评估和定制化解决方案建议
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <a 
              href="/contact"
              className="inline-flex items-center px-8 py-4 bg-white text-teal-600 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line text-xl mr-2"></i>
              <span>立即咨询</span>
            </a>
            <a 
              href="/cases"
              className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-all duration-200 border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line text-xl mr-2"></i>
              <span>查看更多案例</span>
            </a>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 pt-12 border-t border-white/20">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-teal-50">专业技术支持</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">15+</div>
              <div className="text-teal-50">年行业经验</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">98%</div>
              <div className="text-teal-50">客户满意度</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
